/* Product Gallery Splide Loop - v3 */
(function() {
  if (typeof Splide === 'undefined') return;

  function initGallerySplide() {
    var sliderComponent = document.querySelector('slider-component[id^="GalleryViewer"]');
    if (!sliderComponent) return;

    var slider = sliderComponent.querySelector('ul.slider');
    if (!slider) return;

    var slides = slider.querySelectorAll('.slider__slide');
    if (slides.length < 2) return;

    // Construire un mapping mediaId -> index
    var mediaIdToIndex = {};

    // Creer le conteneur Splide
    var splideRoot = document.createElement('div');
    splideRoot.id = 'product-gallery-splide';
    splideRoot.classList.add('splide');

    var splideTrack = document.createElement('div');
    splideTrack.classList.add('splide__track');

    var splideList = document.createElement('ul');
    splideList.classList.add('splide__list');

    // Copier les slides dans le format Splide
    slides.forEach(function(slide, idx) {
      var splideSlide = document.createElement('li');
      splideSlide.classList.add('splide__slide');
      var mediaId = slide.dataset.mediaId || '';
      splideSlide.dataset.mediaId = mediaId;
      splideSlide.innerHTML = slide.innerHTML;
      splideList.appendChild(splideSlide);
      mediaIdToIndex[mediaId] = idx;
    });

    splideTrack.appendChild(splideList);
    splideRoot.appendChild(splideTrack);

    // Remplacer le slider natif par le Splide
    slider.style.display = 'none';
    sliderComponent.insertBefore(splideRoot, slider);

    // Masquer les boutons natifs
    var nativeButtons = sliderComponent.querySelector('.slider-buttons');
    if (nativeButtons) nativeButtons.style.display = 'none';

    // Initialiser Splide en mode loop
    var splide = new Splide('#product-gallery-splide', {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      gap: '0px',
      pagination: true,
      arrows: true,
      drag: true,
      speed: 400,
      easing: 'ease',
      lazyLoad: false
    });

    // Synchroniser avec les thumbnails
    splide.on('moved', function(newIndex) {
      var thumbnails = document.querySelectorAll('.thumbnail-list__item button');
      if (thumbnails.length > 0) {
        thumbnails.forEach(function(thumb, i) {
          thumb.classList.toggle('is-active', i === newIndex);
          if (i === newIndex) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
        var activeThumb = thumbnails[newIndex];
        if (activeThumb) {
          activeThumb.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
        }
      }
    });

    splide.mount();

    // Permettre aux thumbnails de controler le Splide
    var thumbnails = document.querySelectorAll('.thumbnail-list__item button');
    thumbnails.forEach(function(thumb, i) {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        splide.go(i);
      });
    });

    // === SYNCHRONISATION VARIANTES ===
    // Intercepter la methode setActiveMedia de media-gallery
    var mediaGallery = document.querySelector('media-gallery');
    if (mediaGallery && mediaGallery.setActiveMedia) {
      var originalSetActiveMedia = mediaGallery.setActiveMedia.bind(mediaGallery);
      mediaGallery.setActiveMedia = function(mediaId, prepend, filtering, currentVariant) {
        // Appeler la methode originale
        originalSetActiveMedia(mediaId, prepend, filtering, currentVariant);
        // Synchroniser le Splide avec le media actif
        if (mediaId && mediaIdToIndex.hasOwnProperty(mediaId)) {
          var targetIndex = mediaIdToIndex[mediaId];
          if (targetIndex !== splide.index) {
            splide.go(targetIndex);
          }
        }
      };
    }

    // Stocker l'instance pour reference
    window._productGallerySplide = splide;
  }

  // Initialiser quand le DOM est pret
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallerySplide);
  } else {
    // Attendre un tick pour que media-gallery soit initialisee
    setTimeout(initGallerySplide, 100);
  }
})();
